// Saved jobs (feature "savedJobs"): kept only in this browser (localStorage), never sent anywhere.
// A small copy of the card is stored so the Saved page needs no extra request.
const KEY = 'cjl.savedJobs';
const EVENT = 'cjl-saved-jobs';
const MAX = 100;
const FIELDS = ['id', 'title', 'companyName', 'categories', 'city', 'salary', 'postedOn', 'postExpiry', 'externalUrl', 'source'];

export function savedJobs() {
  try {
    const list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
    return Array.isArray(list) ? list.filter((j) => j && j.id) : [];
  } catch (e) {
    return [];
  }
}

function write(list) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch (e) {
    // Storage blocked (private mode): saving just doesn't persist.
  }
  window.dispatchEvent(new Event(EVENT));
}

export const isSaved = (id) => savedJobs().some((j) => j.id === id);

export function toggleSaved(job) {
  const list = savedJobs();
  if (list.some((j) => j.id === job.id)) {
    write(list.filter((j) => j.id !== job.id));
    return false;
  }
  const copy = Object.fromEntries(FIELDS.map((f) => [f, job[f] == null ? '' : String(job[f])]));
  write([{ ...copy, savedAt: new Date().toISOString().slice(0, 10) }, ...list]);
  return true;
}

// Re-render on changes from this tab or another tab.
export function onSavedChange(fn) {
  const storage = (e) => e.key === KEY && fn();
  window.addEventListener(EVENT, fn);
  window.addEventListener('storage', storage);
  return () => {
    window.removeEventListener(EVENT, fn);
    window.removeEventListener('storage', storage);
  };
}
